import {Component} from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-pollembed',
    templateUrl: './pollembed.component.html',
    styleUrl: './pollembed.component.scss'
})
export class PollembedComponent {
    pollId: string | undefined;
    userToken: string | undefined;

    constructor(private readonly snackBar: MatSnackBar,
                private route: ActivatedRoute,) {
        this.route.params
            .subscribe(params => {
                if (params['id']) {
                    this.pollId = params['id'];
                } else {
                    this.openSnackBar('No Invite Token Present', 'error')
                }
                if (params['token']) {
                    this.userToken = params['token'];
                } else {
                    this.openSnackBar('No Invite Token Present', 'error')
                }
            }, error => {
                this.openSnackBar(error, 'error')
                console.error(error);
            });
    }

    openSnackBar(message: string, type: string): void {
        this.snackBar.open(message, 'Dismiss', {
            duration: 5000,
            panelClass: [type]
        });
    }

}
